import AccessLevelTabs from "./AccessLevelTabs";
import FormField from "./FormField";
import ProjectSelect from "./ProjectSelect";
import UserMultiSelect from "./UserMultiSelect";
import type { MCPSharingUserItem } from "../../../services/agent-tools-service";
import type { AccessLevel } from "../types";
import { useTranslation } from "react-i18next";

type Props = {
  accessLevel: AccessLevel;
  onAccessLevelChange: (level: AccessLevel) => void;
  projectId: string;
  onProjectIdChange: (id: string) => void;
  users: MCPSharingUserItem[];
  onUsersChange: (users: MCPSharingUserItem[]) => void;
};

const AccessLevelField = ({
  accessLevel,
  onAccessLevelChange,
  projectId,
  onProjectIdChange,
  users,
  onUsersChange,
}: Props) => {
  const { t } = useTranslation();
  const showProjects = accessLevel === "project";
  const showUsers = accessLevel === "user";
  const hasTarget = showProjects || showUsers;

  return (
    <div
      className={`grid gap-4 ${hasTarget ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1"}`}
    >
      <FormField label={t("mcpPage.fields.accessLevel")}>
        <AccessLevelTabs value={accessLevel} onChange={onAccessLevelChange} />
      </FormField>

      {showProjects && (
        <FormField label={t("mcpPage.fields.project")}>
          <ProjectSelect value={projectId} onChange={onProjectIdChange} />
        </FormField>
      )}

      {showUsers && (
        <FormField label={t("mcpPage.fields.users")}>
          <UserMultiSelect value={users} onChange={onUsersChange} />
        </FormField>
      )}
    </div>
  );
};

export default AccessLevelField;
